import React from 'react';
import './full-page-loader.css';

const FullPageLoader:React.FC = () => {
	return (
		<div id="nprogress">
			<div className="bar" role="bar">
				<div className="peg"></div>
			</div>
			<div className="spinner" role="spinner">
				<div className="spinner-icon"></div>
			</div>
		</div>
	);
};

export default FullPageLoader;
